import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid";
import { Typography } from "@material-ui/core";
import { startCase, camelCase } from "lodash";
import RequireWorkarea from "components/RequireWorkarea";
import RequireOrganization from "components/RequireOrganization";
import { soloNotSupported } from "util/solo";
import AnnotationModal from "./AnnotationModal";
import AnnotationSnackbar from "./AnnotationSnackbar";
import ChartModal from "./ChartModal";
import FilesListCard from "./FilesListCard";
import CastsInFileCard from "./CastsInFileCard";

const AnnotateLayout = props =>
  soloNotSupported(props.workarea, props.organization) ? (
    <Typography variant="h6" style={{ textAlign: "center" }}>
      Solo tools are not supported for the combination of{" "}
      {startCase(camelCase(props.organization))} organization and{" "}
      {startCase(camelCase(props.workarea))} workarea.
    </Typography>
  ) : (
    <RequireOrganization {...props}>
      <RequireWorkarea {...props}>
        <AnnotationModal {...props} />
        <AnnotationSnackbar {...props} />
        <ChartModal {...props} />
        <Row>
          <Col xs={12}>
            <FilesListCard {...props} />
          </Col>
        </Row>

        {props.soloFilesBeingAnnotated.length > 0 && (
          <Row style={{ marginTop: "1rem" }}>
            <Col xs={12}>
              <CastsInFileCard {...props} />
            </Col>
          </Row>
        )}
      </RequireWorkarea>
    </RequireOrganization>
  );

AnnotateLayout.propTypes = {
  soloFilesBeingAnnotated: PropTypes.arrayOf(PropTypes.number),
  workarea: PropTypes.string,
  organization: PropTypes.string
};

AnnotateLayout.defaultProps = {
  soloFilesBeingAnnotated: [],
  workarea: null,
  organization: null
};

export default AnnotateLayout;
